const commonMsalConfig = {
  auth: {
    authority: import.meta.env.VITE_MSAL_AUTH_AUTHORITY,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_AUTH_CLIENTID,
    ...commonMsalConfig.auth,
  },
  cache: {
    ...commonMsalConfig.cache,
  },
};

export const apiScopes = [import.meta.env.VITE_SCOPES_API];

export const graphScopes = ['https://graph.microsoft.com/.default'];
